
import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TrackingFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  isEditing: boolean;
  isPassword?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

export const TrackingField: React.FC<TrackingFieldProps> = ({
  id,
  label,
  value,
  onChange,
  isEditing,
  isPassword = false,
  placeholder = "",
  disabled = false
}) => {
  const [showPassword, setShowPassword] = useState(false);
  
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      
      {isEditing ? (
        <div className="relative">
          <Input
            id={id}
            type={isPassword && !showPassword ? "password" : "text"}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={disabled ? "bg-gray-100 text-gray-500" : ""}
            disabled={disabled}
          />
          
          {isPassword && value && (
            <Button
              type="button"
              variant="ghost"
              size="sm"
              className="absolute right-2 top-1/2 -translate-y-1/2 h-7 w-7 p-0"
              onClick={toggleShowPassword}
              disabled={disabled}
            >
              {showPassword ? (
                <EyeOffIcon className="h-4 w-4" />
              ) : (
                <EyeIcon className="h-4 w-4" />
              )}
            </Button>
          )}
        </div>
      ) : (
        <div className="text-gray-600 dark:text-gray-400">
          {value ? (
            isPassword ? (
              <span>●●●●●●●●●●●●●●●●</span>
            ) : (
              value
            )
          ) : (
            <span className="text-gray-400 dark:text-gray-500 italic">Non configuré</span>
          )}
        </div>
      )}
    </div>
  );
};
